import * as raw from 'java/org/trailcatalog/s2/s2_raw';

export const SimpleS2 = raw.org.trailcatalog.s2.SimpleS2;
